import { Link, useRouterState } from '@tanstack/react-router'
import { docsNavigation } from '@/features/docs/config/navigation'
import { cn } from '@/lib/utils'

export function DocsSidebar({ onNavigate }: { onNavigate?: () => void }) {
  const routerState = useRouterState()
  const currentPath = routerState.location.pathname

  return (
    <nav className="w-full">
      {docsNavigation.map((section) => (
        <div key={section.title} className="mb-6">
          <p className="px-3 mb-1.5 text-xs font-semibold uppercase tracking-widest text-[var(--color-text-tertiary)]">
            {section.title}
          </p>
          {section.groups.map((group) => (
            <div key={group.title} className="mb-4">
              {/* Group label — only shown when group has a title and multiple items */}
              {group.title && group.items.length > 1 && (
                <p className="px-3 mb-1 text-xs font-medium text-[var(--color-text-tertiary)] opacity-70">
                  {group.title}
                </p>
              )}
              <ul className="space-y-0.5">
                {group.items.map((item) => {
                  const href = `/docs/${item.slug}`
                  const isActive = currentPath === href
                  return (
                    <li key={item.slug}>
                      <Link
                        to={href}
                        onClick={onNavigate}
                        className={cn(
                          'flex items-center gap-2 px-3.5 py-1.5 rounded-full text-sm transition-colors duration-300 ease-brisk',
                          isActive
                            ? 'bg-primary/10 text-primary font-medium'
                            : 'text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:bg-[var(--color-control-surface-hover)]',
                        )}
                      >
                        {isActive && (
                          <span className="w-1 h-1 rounded-full bg-primary shrink-0" />
                        )}
                        {item.title}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          ))}
        </div>
      ))}
    </nav>
  )
}
